module.exports = __webpack_public_path__ + "img/brand(5).c95a00db.png";